/* unplugin-vue-components disabled */import script from "./applyList.vue?vue&type=script&setup=true&lang=js"
export * from "./applyList.vue?vue&type=script&setup=true&lang=js"

import "./applyList.vue?vue&type=style&index=0&id=500dd081&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500dd081"]])

export default __exports__